import "./App.css";
import { useLocation } from "react-router-dom";
import Footer from "./Components/Footer/Footer";
import Connect from "./Components/Home/Connect";
import Navbar from "./Components/Navbar/Navbar";
import Router from "./Components/Router";
import ScrollToTop from "./Components/ScrollToTop";  // <-- Import here

function App() {
  const location = useLocation();

  // Define the routes where NavBarPage and Footer should not be displayed
  const noHeaderFooterRoutes = [
    "/admin-login",
    "/admin-dashboard",
    
  ];
  // Check if the current route matches any of the specified routes
  const hideHeaderFooter = noHeaderFooterRoutes.some((route) =>
    location.pathname.startsWith(route)
  );
  return (
    <div className="App">
      
      {!hideHeaderFooter && <Navbar />}
        <ScrollToTop />  {/* <-- Add this component */}
        <Router />
        {!hideHeaderFooter &&  <Connect/>}
          {!hideHeaderFooter &&  <Footer />}
      
    </div>
  );
}

export default App;
